var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 22,
    viewBox: "0 0 47 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 4.92487 4.92487 0 11 0H36C42.0751 0 47 4.92487 47 11C47 17.0751 42.0751 22 36 22H11C4.92487 22 0 17.0751 0 11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5H36C41.799 0.5 46.5 5.20101 46.5 11C46.5 16.799 41.799 21.5 36 21.5H11C5.20101 21.5 0.5 16.799 0.5 11C0.5 5.20101 5.20101 0.5 11 0.5Z",
    stroke: "#8951FF",
    strokeOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 3.99996C17.6343 9.40804 19.141 10.9986 24 11C19.3423 11.6593 17.4639 12.8207 17 18C16.9947 14.007 14.8543 11.5636 10 11C14.9221 10.7648 16.6284 9.43173 17 3.99996Z",
    fill: "#8951FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0875 12.497L30.1195 9.8515C30.0718 9.73417 30.0223 9.59483 29.971 9.4335C29.9197 9.27217 29.8683 9.098 29.817 8.911C29.7693 9.098 29.7198 9.274 29.6685 9.439C29.6172 9.60033 29.5677 9.7415 29.52 9.8625L28.5575 12.497H31.0875ZM33.7 15.5H32.556C32.4277 15.5 32.3232 15.4688 32.2425 15.4065C32.1618 15.3405 32.1013 15.2598 32.061 15.1645L31.467 13.542H28.1725L27.5785 15.1645C27.5492 15.2488 27.4923 15.3258 27.408 15.3955C27.3237 15.4652 27.2192 15.5 27.0945 15.5H25.9395L29.069 7.547H30.576L33.7 15.5ZM36.0082 15.5H34.5232V7.547H36.0082V15.5Z",
    fill: "#8951FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(10 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiTag);
export default __webpack_public_path__ + "static/media/ai-tag.fd386fe21da2c869476f6a1e6414780e.svg";
export { ForwardRef as ReactComponent };